import React from 'react';

import {assert} from 'Asserts';
import {TargetSample} from 'folder-items/FileConstants';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {requestFetchManagedModel} from 'models/ManagedModelUtil';
import StorableSummaryExtrasManager from 'models/managers/StorableSummaryExtrasManager';
import ContainerLink from 'samples/containers/ContainerLink';
import AncestralStorables from 'samples/storables/AncestralStorables';
import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import StageRunSampleLink from 'workflows/components/StageRunSampleLink';
import {PreparedSample} from 'workflows/samples/PreparedSampleGroupConstants';

export interface RequestSampleCellProps {
  samples: Array<PreparedSample | TargetSample>;
  tagSchemaField?: SchemaFieldConstants.SchemaField;
}

class RequestSampleCell extends React.Component<RequestSampleCellProps> {
  override componentDidMount(): void {
    this._fetchContainerData();
  }

  override componentDidUpdate(): void {
    this._fetchContainerData();
  }

  _fetchContainerData(): void {
    const sample = this._getSample();
    // eslint-disable-next-line benchlint/no-in-operator
    if (sample && 'containerId' in sample && sample.containerId) {
      requestFetchManagedModel(ManagedModelType.CONTAINER, sample.containerId);
      StorableSummaryExtrasManager.requestFetch(sample.containerId); // Fetch extras for AncestralStorables.
    }
  }

  _getSample(): PreparedSample | TargetSample | null {
    const samples = this.props.samples;
    assert(samples.length <= 1, 'Expected at most 1 sample per field per sample group');
    return samples.length > 0 ? samples[0] : null;
  }

  override render(): JSX.Element | null {
    const sample = this._getSample();
    if (!sample) {
      return null;
    }

    return (
      <div>
        <StageRunSampleLink sample={sample} />
        {
          // eslint-disable-next-line benchlint/no-in-operator
          'containerId' in sample &&
            sample.containerId && [
              <span key="containerLink">
                {' ('}
                <ContainerLink containerId={sample.containerId} />)
              </span>,
              <div key="ancestralStorables">
                <AncestralStorables
                  className="richObjectTable-detailText"
                  storableId={sample.containerId}
                  noLocationText="No location"
                  showGridCell={true}
                  truncate={true}
                />
              </div>,
            ]
        }
      </div>
    );
  }
}

export default RequestSampleCell;
